import { render, staticRenderFns } from "./BoostingMailFormDialog.vue?vue&type=template&id=574ed02c"
import script from "./BoostingMailFormDialog.vue?vue&type=script&lang=js"
export * from "./BoostingMailFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports